import React from 'react';
import ReactHTMLParser from 'react-html-parser';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

import { SecondaryButton } from '../Button/variants';
import IconTheWeekend from '../Images/Rebranding/IconTheWeekend';

interface UnitHeaderProps {
  isTheWeekend?: boolean;
  unitName: string;
  unitDescription?: string;
  viewAllUrl: string;
}

const UnitHeader = ({ isTheWeekend, unitName, unitDescription, viewAllUrl }: UnitHeaderProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <div className="mb-32 flex items-start justify-between sm:mb-36">
      <div>
        {isTheWeekend ? (
          <IconTheWeekend className="w-[240px]" />
        ) : (
          <h2 className="m-0 font-suisse-intl-mono text-feed-headline-sm sm:text-feed-headline-lg">
            {unitName}
          </h2>
        )}
        {unitDescription && (
          <p className="m-0 font-suisse-screen text-body-md sm:text-body-lg">
            {ReactHTMLParser(unitDescription)}
          </p>
        )}
      </div>
      <SecondaryButton
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ViewAllArticles }))}
        as="link"
        href={viewAllUrl}
        className="ml-4 hidden sm:inline-block"
      >
        View all
      </SecondaryButton>
    </div>
  );
};

export default UnitHeader;
